// Should correspond to subjects defined in newsela/people/models/educator.py

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import { Subject, SubjectSlug } from "./subjects.type";

export const ENGLISH_LANGUAGE_ARTS = "English/Language Arts/Reading";

export const ENGLISH_LANGUAGE_LEARNERS = "English Language Learners";

export const FOREIGN_LANGUAGE = "Foreign Language";

export const GENERAL_ELEMENTARY = "General Elementary";

export const MATH = "Math";

export const SCIENCE = "Science";

export const SOCIAL_STUDIES = "Social Studies/Social Science";

export const SPECIAL_EDUCATION = "Special Education";

export const OTHER = "Other";

export const allSubjects = [
  ENGLISH_LANGUAGE_ARTS,
  ENGLISH_LANGUAGE_LEARNERS,
  FOREIGN_LANGUAGE,
  GENERAL_ELEMENTARY,
  MATH,
  SCIENCE,
  SOCIAL_STUDIES,
  SPECIAL_EDUCATION,
  OTHER,
] as const;

export const allSubjectsSlugs = {
  ENGLISH_LANGUAGE_ARTS: "english-arts-reading",
  ENGLISH_LANGUAGE_LEARNERS: "english-language-learner",
  FOREIGN_LANGUAGE: "foreign-language",
  GENERAL_ELEMENTARY: "general-elementary",
  MATH: "math",
  SCIENCE: "science",
  SOCIAL_STUDIES: "social-studies",
  SPECIAL_EDUCATION: "special-education",
  OTHER: "other",
};

export const subjectForSlug: Record<SubjectSlug, Subject> = {
  "english-arts-reading": ENGLISH_LANGUAGE_ARTS,
  "english-language-learner": ENGLISH_LANGUAGE_LEARNERS,
  "foreign-language": FOREIGN_LANGUAGE,
  "general-elementary": GENERAL_ELEMENTARY,
  math: MATH,
  science: SCIENCE,
  "social-studies": SOCIAL_STUDIES,
  "special-education": SPECIAL_EDUCATION,
  other: OTHER,
};

export const subjectToSlug: Record<Subject, SubjectSlug> = {
  [ENGLISH_LANGUAGE_ARTS]: "english-arts-reading",
  [ENGLISH_LANGUAGE_LEARNERS]: "english-language-learner",
  [FOREIGN_LANGUAGE]: "foreign-language",
  [GENERAL_ELEMENTARY]: "general-elementary",
  [MATH]: "math",
  [SCIENCE]: "science",
  [SOCIAL_STUDIES]: "social-studies",
  [SPECIAL_EDUCATION]: "special-education",
  [OTHER]: "other",
};

export const BrowseSubjectPagesTitles = {
  ELA: "English Language Arts",
  SCIENCE: "Science",
  SOCIAL_STUDIES: "Social Studies",
};

export const BrowseSubjectPagesSlugs = {
  ELA: "ela-browse-page",
  SCIENCE: "browse-science",
  SOCIAL_STUDIES: "browse-social-studies",
};

// The below page arrays are intended for constructing Browse Navigation
export const BrowseSubjectPages = [
  {
    title: BrowseSubjectPagesTitles.ELA,
    url: `${MONOLITH_ORIGIN}/content/browse/ela-browse-page`,
  },
  {
    title: BrowseSubjectPagesTitles.SCIENCE,
    url: `${MONOLITH_ORIGIN}/content/browse/browse-science`,
  },
  {
    title: BrowseSubjectPagesTitles.SOCIAL_STUDIES,
    url: `${MONOLITH_ORIGIN}/content/browse/browse-social-studies`,
  },
];

export const BrowseTopicPages = [
  { title: "News", url: `${MONOLITH_ORIGIN}/content/browse/news-browse-page` },
];

export const BrowseLanguagePages = [
  {
    title: "En Español",
    lang: "es",
    url: `${MONOLITH_ORIGIN}/content/browse/spanish-browse-page`,
  },
];
